<template>
  <div class="detalhe-pedido">
    <section class="content">
      <spinnerProcessando
        cssClass="ml-2"
        :status="flagsDeControle.carregandoDados.status"
        :mensagem="flagsDeControle.carregandoDados.mensagem"
      />
      <div class="card"  v-if="!flagsDeControle.carregandoDados.status">
        <div class="card-body">
          <div class="row">
            <h5 class="text-bold">{{obterDescricaoFatura}}</h5>
          </div>
          <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
              <div class="d-flex justify-content-between">
                <span class="text-muted mr-2">Data de Emissão:</span>
                <span class="text-bold">{{
                  $date(this.detalheFatura.data_emissao).format(
                    "DD/MM/YYYY"
                  )
                }}</span>
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
              <div class="d-flex justify-content-between">
                <span class="text-muted mr-2">Status:</span>
                <span
                  :class="{
                    statusPago: detalheFatura.status === 1,
                    statusPendente:
                      detalheFatura.status === 2 ||
                      detalheFatura.status === 4,
                    statusAberto: detalheFatura.status === 3,
                  }"
                  >{{
                    obterDescricaoStatusFatura(detalheFatura.status)
                  }}</span
                >
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
              <div class="d-flex justify-content-between">
                <span class="text-muted mr-2">Vencimento da Fatura:</span>
                <span class="text-bold text-right">{{
                  $date(this.detalheFatura.data_vencimento).format(
                    "DD/MM/YYYY"
                  )
                }}</span>
              </div>
            </div>
            <div class="col-6">
              <div class="row" v-if="cupomSelecionado">
                <div class="col-xl-12 col-lg-12 col-md-6 col-sm-6 col-xs-12">
                  <div class="d-flex justify-content-between">
                    <span class="text-muted mr-2">Subtotal:</span>
                    <span class="text-bold">{{ formatarValorMonetario(subTotal) }}</span>
                  </div>
                </div>
                <div class="col-xl-12 col-lg-12 col-md-6 col-sm-6 col-xs-12">
                  <div class="d-flex justify-content-between">
                    <span class="text-muted mr-2">Desconto:</span>
                    <span class="text-bold">{{ formatarValorMonetario(desconto) }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12"></div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
              <div class="d-flex justify-content-between">
                <span class="text-muted mr-2">Total:</span>
                <span class="text-bold">{{ formatarValorMonetario(detalheFatura.valor_total) }}</span>
              </div>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-auto">
              <h5 class="tituloH5GestaoConta">Forma de Pagamento</h5>
            </div>
          </div>
          <div v-if="this.detalheFatura.forma_pagamento === 'Boleto'">
            <div class="row">
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                <div class="d-flex justify-content-between">
                  <span class="text-muted mr-2">Forma de Pagamento:</span>
                  <span class="text-bold">{{this.detalheFatura.forma_pagamento}}</span>
                </div>
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                <div class="d-flex justify-content-between">
                  <span class="text-muted mr-2">Status:</span>
                  <span :class="[obterCorStatusCredito]">{{obterDescricaoStatusPagamento(detalheFatura.status_id)}}</span>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                <div class="d-flex justify-content-between">
                  <span class="text-muted">Vencimento do boleto:</span>
                  <span class="text-bold">{{$date(this.detalheFatura.data_vencimento).format("DD/MM/YYYY")}}</span>
                </div>
              </div>
              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div class="d-flex align-items-center flex-wrap">
                  <span class="text-muted">Codigo de Barra:</span>
                  <span class="font-weight-bold text-dark codigo-barras ml-1" id="codigoBarras">{{ this.detalheFatura.codigo_barras }}</span>
                  <span v-if="feedbackCodigo">Copiado!</span>
                  <a class="btn btn-sm btn-white" v-if="detalheFatura.codigo_barras" @click="copiarTexto('codigoBarras', 'feedbackCodigo')" data-toggle="tooltip" data-placement="top" title="Copiar Código de Barra">
                    <i class="fa fa-clone text-secondary"></i>
                  </a>
                  <a class="btn btn-white" data-toggle="tooltip" data-placement="top" title="Download boleto" v-if="detalheFatura.url" @click="baixarBoleto(detalheFatura.url)">
                    <i class="fa fa-download text-secondary"></i>
                  </a>
                </div>
              </div>
            </div>
          </div><!-- FIM BOLETO -->

          <div v-if="this.detalheFatura.forma_pagamento === 'Pix'">
            <div class="row">
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                <div class="d-flex justify-content-between">
                  <span class="text-muted mr-2">Forma de Pagamento:</span>
                  <span class="text-bold">{{this.detalheFatura.forma_pagamento}}</span>
                </div>
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                <div class="d-flex justify-content-between">
                  <span class="text-muted mr-2">Status:</span>
                  <span :class="[obterCorStatusCredito]">{{obterDescricaoStatusPagamento(detalheFatura.status_id)}}</span>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                <div class="d-flex align-items-center flex-wrap">
                  <span class="text-muted">Codigo:</span>
                  <code class="font-weight-bold text-dark ml-1" id="codigoPix">{{ this.detalheFatura.chave_pix }}</code>
                  <span v-if="feedbackCodigo">Copiado!</span>
                  <a class="btn btn-white" v-if="detalheFatura.chave_pix" @click="copiarTexto('codigoPix', 'feedbackCodigo')"
                    data-toggle="tooltip" data-placement="top" title="Copiar Código">
                    <i class="fa fa-clone text-secondary"></i>
                  </a>
                </div>
              </div>
              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <img style="height: 200px;" :src="detalheFatura.url" v-if="detalheFatura.url">
              </div>
            </div>
          </div> <!-- FIM PIX-->

          <div v-if="this.detalheFatura.forma_pagamento === 'Cartão de crédito'">
            <div class="row">
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                <div class="d-flex justify-content-between">
                  <span class="text-muted mr-2">Forma de Pagamento:</span>
                  <span class="text-bold">{{this.detalheFatura.forma_pagamento}}</span>
                </div>
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12"  v-if="detalheFatura.digitos_cartao">
                <div class="d-flex justify-content-between">
                  <span class="text-muted mr-2">Número do cartão</span>
                  <div class="d-flex justify-content-end">
                    <b-img
                      :blank="!possuiBandeiraCartao"
                      v-if="possuiBandeiraCartao"
                      :src="obterImagemBandeiraCartao" :fluid="true" alt="bandeira cartão de crédito"
                      width="30" class="mr-1 text-right" />
                    <code class="text-bold text-dark" id="codigoBarras">{{ formatarCartaoCredito(detalheFatura.digitos_cartao) }}</code>
                  </div>
                </div>
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                <div class="d-flex justify-content-between">
                  <span class="text-muted mr-2">Status:</span>
                  <span :class="[obterCorStatusCredito]">{{obterDescricaoStatusPagamento(detalheFatura.status_id)}}</span>
                </div>
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12" v-if="detalheFatura.mensagem_retorno">
                <div class="d-flex justify-content-between">
                  <span class="text-muted mr-2">Mensagem:</span>
                  <span class="text-bold">{{detalheFatura.mensagem_retorno}}</span>
                </div>
              </div>
            </div>
          </div> <!-- FIM CARTAO -->

          <div class="row mt-3" v-if="detalheFatura.nota_status_id == 4">
            <div class="col-12">
              Nota Fiscal: {{ detalheFatura.numero_nota }}
              <a
                class="btn btn-white"
                @click="visualizarNotaFiscal(detalheFatura.id)"
                data-toggle="tooltip"
                data-placement="top"
                title="Visualizar Nota Fiscal em PDF"
              >
                <i class="fa fa-clone text-secondary"></i> Visualizar PDF
              </a>
              <a
                class="btn btn-white"
                data-toggle="tooltip"
                data-placement="top"
                title="Download XML"
                @click="baixarNotaFiscal(detalheFatura.id)"
              >
                <i class="fa fa-download text-secondary"></i> Baixar XML
              </a>
            </div>
          </div>
          <div class="row mt-4">
            <h5 class="tituloH5GestaoConta">Itens da Fatura</h5>
            <div class="col-12">
              <div class="table-responsive">
                <table class="table">
                  <thead>
                    <tr>
                      <th scope="col">Serviço</th>
                      <th scope="col">Descrição</th>
                      <th scope="col" class="text-center">Quantidade</th>
                      <th scope="col" class="text-center">Valor</th>
                      <th scope="col" class="text-center">Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in this.itensDaFatura"
                      :key="index"
                    >
                      <td>{{ item.produto_nome }}</td>
                      <td>{{ item.descricao }}</td>
                      <td class="text-center col-1">{{ item.quantidade }}</td>
                      <td class="text-center col-2">{{ formatarValorMonetario(item.valor) }}</td>
                      <td class="text-center col-2">{{ formatarValorMonetario(calcularSubTotalDoItem(item.quantidade, item.valor)) }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="card-footer text-right">
          <div class="row btn-group-justified justify-content-end" role="group">
            <button class="btn btn-md btn-light border-secondary" @click="$emit('voltar')">Voltar</button>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import DetalhePedido from './js/detalhe-pedido'

export default {
  ...DetalhePedido,
  props: {
    pedidoId: {
      type: [String, Number],
      required: true
    }
  }
}
</script>

<style scoped>
@import "../faturas/scss/detalhe.scss";
</style>
